/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'network';
const componentName = 'configured-network-subnet-expander';
const prefix = `${moduleName}.${componentName}`;

export const ipSubnetLabel = `${prefix}.ipSubnetLabel`;
export const staticIpPoolsLabel = `${prefix}.staticIpPoolsLabel`;

export const ENGLISH = {
    [ipSubnetLabel]: 'IP Subnet (Configured)',
    [staticIpPoolsLabel]: 'Static IP Pools (Type)',
};
